import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Download.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: n }));
a.displayName = "DownloadIcon";
const s = a;
export {
  s as Download,
  a as DownloadIcon
};
